export const BACK_OFFICE_ROLE = {
  1: "Admin",
  2: "Scheduler",
  3: "Executive",
  4: "Creator",
};

export const COMMUNITY_ROLE = {
  1: "Nurse",
  2: "Admin",
  3: "Supervisor",
};

export const USER_ROLE = {
  1: "Back Office",
  2: "Community",
  3: "Provider",
  4: "Patient",
  5: "Patient POC",
};

export const ACTIVITY_TYPE = {
  SCHEDULE_PUBLISH: "SCHEDULE_PUBLISH",
  APPOINTMENT_CREATED: "APPOINTMENT_CREATED",
  DISPATCH_APPOINTMENT_CREATED: "DISPATCH_APPOINTMENT_CREATED",
  DISPATCH_APPOINTMENT_PUBLISHED: "DISPATCH_APPOINTMENT_PUBLISHED",
  APPOINTMENT_CANCELED: "APPOINTMENT_CANCELED",
  SEQUENCE_CHANGE: "SEQUENCE_CHANGE",
  VISIT_STATUS_CHANGE: "VISIT_STATUS_CHANGE",
  VISIT_LOCKED: "VISIT_LOCKED",
  VISIT_UNLOCKED: "VISIT_UNLOCKED",
  DOWNLOAD_SCHEDULES: "DOWNLOAD_SCHEDULES",
  PROVIDER_ADD: "PROVIDER_ADD",
  PROVIDER_UPLOAD: "PROVIDER_UPLOAD",
  PROVIDER_UPDATE: "PROVIDER_UPDATE",
  PROVIDER_DELETE: "PROVIDER_DELETE",
  POC_ADD: "POC_ADD",
  POC_UPDATE: "POC_UPDATE",
  POC_DELETE: "POC_DELETE",
  PATIENT_NOTE_UPDATE: "PATIENT_NOTE_UPDATE",
  COMMUNITY_ADD: "COMMUNITY_ADD",
  COMMUNITY_UPDATE: "COMMUNITY_UPDATE",
  COMMUNITY_DELETE: "COMMUNITY_DELETE",
  COMMUNITY_STAFF_ADD: "COMMUNITY_STAFF_ADD",
  COMMUNITY_STAFF_UPDATE: "COMMUNITY_STAFF_UPDATE",
  COMMUNITY_STAFF_DELETE: "COMMUNITY_STAFF_DELETE",
  ZONE_ADD: "ZONE_ADD",
  ZONE_UPDATE: "ZONE_UPDATE",
  ZONE_INACTIVE: "ZONE_INACTIVE",
  CARETAG_ADD: "CARETAG_ADD",
  CARETAG_UPDATE: "CARETAG_UPDATE",
  CARETAG_INACTIVE: "CARETAG_INACTIVE",
  PROVIDER_SETTINGS_UPDATE: "PROVIDER_SETTINGS_UPDATE",
  VISIT_RULES_COMMUNITY_UPDATE: "VISIT_RULES_COMMUNITY_UPDATE",
  VISIT_RULES_HOME_UPDATE: "VISIT_RULES_HOME_UPDATE",
  BACK_OFFICE_USER_ADD: "BACK_OFFICE_USER_ADD",
  BACK_OFFICE_USER_UPDATE: "BACK_OFFICE_USER_UPDATE",
  BACK_OFFICE_USER_DELETE: "BACK_OFFICE_USER_DELETE",
  APPOINTMENT_NOTE_ADD: "APPOINTMENT_NOTE_ADD",
  APPOINTMENT_NOTE_UPDATE: "APPOINTMENT_NOTE_UPDATE",
  APPOINTMENT_NOTE_DELETE: "APPOINTMENT_NOTE_DELETE",
  PROVIDER_TIME_OFF_CREATE: "PROVIDER_TIME_OFF_CREATE",
  PROVIDER_TIME_OFF_UPDATE: "PROVIDER_TIME_OFF_UPDATE",
  PROVIDER_TIME_OFF_DELETE: "PROVIDER_TIME_OFF_DELETE",

  PROVIDER_WEEKLY_RANGE_ASSIGNMENT: "PROVIDER_WEEKLY_RANGE_ASSIGNMENT",
  PROVIDER_ASSIGNMENT_DELETE: "PROVIDER_ASSIGNMENT_DELETE",
  PROVIDER_AVAILABILITY_TEMPLATE_CREATE: "PROVIDER_AVAILABILITY_TEMPLATE_CREATE",
  PROVIDER_AVAILABILITY_TEMPLATE_UPDATE: "PROVIDER_AVAILABILITY_TEMPLATE_UPDATE",
  PROVIDER_AVAILABILITY_TEMPLATE_DELETE: "PROVIDER_AVAILABILITY_TEMPLATE_DELETE",

  RBAC_CONFIGURATION_UPDATE: "RBAC_CONFIGURATION_UPDATE",
  USER_ADD: "USER_ADD",
  USER_UPDATE: "USER_UPDATE",
  USER_DELETE: "USER_DELETE",
  INVITE_USER: "INVITE_USER",

};

export const ACTIVITY_STATUS = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export const reasons = [
  "PATIENT CANCELLED",
  "PATIENT NO SHOW",
  "PATIENT RESCHEDULED",
  "PROVIDER CANCELLED",
  "PROVIDER UNAVAILABLE",
  "SCHEDULING ERROR",
];

export const APPOINTMENT_STATUS = {
  COMPLETED: "COMPLETED",
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
  SCHEDULED: "SCHEDULED",
  NOSHOW: "NOSHOW",
};

export const ADDRESS_GEN_TYPE = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
  RELATIVE: 'RELATIVE'
}

export const GENDER = {
  M: "Male",
  F: "Female",
  O: "Other",
};

export const languages = [
  {
    name: "None",
    iso_639_1: "None",
    iso_639_2: "",
  },
  {
    name: "English",
    iso_639_1: "en",
    iso_639_2: "eng",
  },
  {
    name: "Mandarin Chinese",
    iso_639_1: "zh",
    iso_639_2: "zho",
  },
  {
    name: "Spanish",
    iso_639_1: "es",
    iso_639_2: "spa",
  },
  {
    name: "Hindi",
    iso_639_1: "hi",
    iso_639_2: "hin",
  },
  {
    name: "Arabic",
    iso_639_1: "ar",
    iso_639_2: "ara",
  },
  {
    name: "Bengali",
    iso_639_1: "bn",
    iso_639_2: "ben",
  },
  {
    name: "Portuguese",
    iso_639_1: "pt",
    iso_639_2: "por",
  },
  {
    name: "Russian",
    iso_639_1: "ru",
    iso_639_2: "rus",
  },
  {
    name: "Japanese",
    iso_639_1: "ja",
    iso_639_2: "jpn",
  },
  {
    name: "Punjabi",
    iso_639_1: "pa",
    iso_639_2: "pan",
  },
  {
    name: "German",
    iso_639_1: "de",
    iso_639_2: "deu",
  },
  {
    name: "Javanese",
    iso_639_1: "jv",
    iso_639_2: "jav",
  },
  {
    name: "Korean",
    iso_639_1: "ko",
    iso_639_2: "kor",
  },
  {
    name: "French",
    iso_639_1: "fr",
    iso_639_2: "fra",
  },
  {
    name: "Turkish",
    iso_639_1: "tr",
    iso_639_2: "tur",
  },
  {
    name: "Vietnamese",
    iso_639_1: "vi",
    iso_639_2: "vie",
  },
  {
    name: "Telugu",
    iso_639_1: "te",
    iso_639_2: "tel",
  },
  {
    name: "Marathi",
    iso_639_1: "mr",
    iso_639_2: "mar",
  },
  {
    name: "Tamil",
    iso_639_1: "ta",
    iso_639_2: "tam",
  },
  {
    name: "Urdu",
    iso_639_1: "ur",
    iso_639_2: "urd",
  },
  {
    name: "Italian",
    iso_639_1: "it",
    iso_639_2: "ita",
  },
  {
    name: "Persian (Farsi)",
    iso_639_1: "fa",
    iso_639_2: "fas",
  },
  {
    name: "Gujarati",
    iso_639_1: "gu",
    iso_639_2: "guj",
  },
  {
    name: "Polish",
    iso_639_1: "pl",
    iso_639_2: "pol",
  },
  {
    name: "Ukrainian",
    iso_639_1: "uk",
    iso_639_2: "ukr",
  },
  {
    name: "Malayalam",
    iso_639_1: "ml",
    iso_639_2: "mal",
  },
  {
    name: "Kannada",
    iso_639_1: "kn",
    iso_639_2: "kan",
  },
  {
    name: "Odia (Oriya)",
    iso_639_1: "or",
    iso_639_2: "ori",
  },
  {
    name: "Thai",
    iso_639_1: "th",
    iso_639_2: "tha",
  },
  {
    name: "Dutch",
    iso_639_1: "nl",
    iso_639_2: "nld",
  },
  {
    name: "Romanian",
    iso_639_1: "ro",
    iso_639_2: "ron",
  },
  {
    name: "Greek",
    iso_639_1: "el",
    iso_639_2: "ell",
  },
  {
    name: "Hungarian",
    iso_639_1: "hu",
    iso_639_2: "hun",
  },
  {
    name: "Czech",
    iso_639_1: "cs",
    iso_639_2: "ces",
  },
  {
    name: "Swedish",
    iso_639_1: "sv",
    iso_639_2: "swe",
  },
  {
    name: "Hebrew",
    iso_639_1: "he",
    iso_639_2: "heb",
  },
  {
    name: "Finnish",
    iso_639_1: "fi",
    iso_639_2: "fin",
  },
  {
    name: "Norwegian",
    iso_639_1: "no",
    iso_639_2: "nor",
  },
  {
    name: "Danish",
    iso_639_1: "da",
    iso_639_2: "dan",
  },
  {
    name: "Swahili",
    iso_639_1: "sw",
    iso_639_2: "swa",
  },
];

export const REFERRAL_SOURCE_TYPE = {
  HOSPITAL: "Hospital",
  PHYSICIAN: "Physician",
  ASSISTED_LIVING_FACILITY: "Assisted Living Facility",
  INSURANCE: "Insurance",
  FAMILY_SELF: "Family/Self",
  COMMUNITY_ORGANIZATION: "Community Organization",
  PREVIOUS_PATIENT: "Previous Patient",
  OTHER: "other",
};

export const BULK_ACTIONS = {
  CANCEL: "cancel",
  RESCHEDULE: "reschedule",
  COPY: "copy",
  LOCK: "lock",
  UNLOCK: "unlock",
};

export const WARNING_LABELS = {
  cancel:
    "This will permanently cancel all appointments. Patients will need to be notified. This action cannot be undone.",
  lock: "This will prevent any changes to these appointments until they are unlocked.",
};

export const routingOptions = [
  { label: "< 50 miles", value: "50" },
  { label: "< 75 miles", value: "75" },
  { label: "< 100 miles", value: "100" },
  { label: "≥ 100 miles", value: null },
];

export const genderPreferenceOptions = [
  { label: "Any", value: "Any" },
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];

export const dispatchSortOptions = [
  { value: 1, label: "Best match" },
  { value: 2, label: "Least distance added" },
  { value: 3, label: "Least total distance" },
  { value: 4, label: "Least appointments" },
  { value: 5, label: "Smallest patient panel" },
];

export const payers = [
  "Florida Blue",
  "Arkansas BCBS",
  "Florida Health Care Plan",
];

export const lobs = ["Medicare", "Medicaid", "Commercial"];

export const programs = ["IHA", "ACC", "APC"];

export const states = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM",
  "NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA",
  "WV","WI","WY","PR"
];

export const POC_TYPE = {
  SELF: "Self",
  SON: "Son",
  DAUGHTER: "Daughter",
  OTHER: "Other",
  LEGAL_GUARDIAN: "Legal Guardian",
  COMMUNITY_STAFF: "Community Staff",
  SPOUSE: "Spouse",
  CHILD: "Child",
  PARENT: "Parent",
  SIBLING: "Sibling",
  FRIEND: "Friend",
  COUSIN: "Cousin",
  GUARDIAN: "Guardian",
  UNKNOWN: "Unknown",
};

export const specialitiesList = [
  "Family Medicine",
  "Internal Medicine",
  "Psychiatrists",
  "Podiatrists",
  "Cardiologists",
  "Other",
];

export const STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];



export const APPOINTMENT_CREATED_FROM = {
  CC_HOME: 'CC_HOME',
  EHR: 'EHR',
  DISPATCH: 'DISPATCH',
  CALENDAR_VIEW: 'CALENDAR_VIEW',
  SCHEDULER_GENERATED: 'SCHEDULER_GENERATED',
  FILE_UPLOAD: 'FILE_UPLOAD',
}